import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.dialog)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dialog), _mergeProps({ key: 0 }, _ctx.props, { key: _ctx.key }), null, 16))
    : _createCommentVNode("", true)
}